
<LayoutGrid
  v-if="grid"
  ref="gridRef"
  class="sdv-activation-preview-list-grid"
  :grid="grid"
  style="pointer-events: none;"
>
  <template #default="{ area }">
    <slot
      :items="itemsMap[area]"
      :options="getOptions(area)"
      :on="listListeners"
    >
      <ActivationPreviewList
        :items="itemsMap[area]"
        :options="getOptions(area)"
        style="pointer-events: all;"
        :style="getListStyles(area)"
        :animation="animation"
        v-on="listListeners"
      />
    </slot>
  </template>
</LayoutGrid>
